export function initExperiencePro() {
    const section = document.querySelector('#experience');
    if (!section) return;

    const visualBox = section.querySelector('.bt-visual-box--room');
    const overlay = section.querySelector('.bt-room__overlay');
    if (!visualBox || !overlay) return;

    const bulletItems = Array.from(section.querySelectorAll('.bt-experience__bullets [data-exp-key]'));
    const markerButtons = Array.from(section.querySelectorAll('.bt-exp-marker[data-key]'));
    const statusValue = section.querySelector('.bt-experience__status-value');

    const LIGHT_SCENE_MS = 9000;  // 3 сек утро + 3 сек вечер + 3 сек ночь
    const MODE_MS = 7000;         // climate / security / network
    const CLIMATE_MS = 4200;
    const NETWORK_CYCLE_MS = 2800;

    const MODE_LABELS = {
        light: 'Освещение',
        climate: 'Климат',
        security: 'Безопасность',
        network: 'Сеть'
    };

    let startTime = performance.now();
    let active = overlay.getAttribute('data-active') || 'light';
    let userInteracted = false;

    let autoplayTimer = null;
    let climateTimer = null;
    let networkTimer = null;
    let rafId = null;

    let animToggle = overlay.getAttribute('data-anim') || 'a';

    let isSceneVisible = false;
    let autoplayRunning = false;
    let sequenceIndex = 0;

    const sequence = [
        { key: 'light', duration: LIGHT_SCENE_MS },
        { key: 'climate', duration: MODE_MS },
        { key: 'security', duration: MODE_MS },
        { key: 'network', duration: MODE_MS }
    ];

    setOverlayAttr('data-anim', animToggle);
    setOverlayAttr('data-network-state', 'final');

    function setOverlayAttr(name, value) {
        overlay.setAttribute(name, value);
    }

    function updateStatusLabel() {
        if (!statusValue) return;
        statusValue.textContent = MODE_LABELS[active] || MODE_LABELS.light;
    }

    function syncBullets() {
        bulletItems.forEach(function (item) {
            const key = item.getAttribute('data-exp-key');
            item.classList.toggle('is-active', key === active);
        });
    }

    function syncMarkers() {
        markerButtons.forEach(function (btn) {
            const key = btn.getAttribute('data-key');
            btn.classList.toggle('is-active', key === active);
        });
    }

    function setTimePhase(progress) {
        let phase;

        if (progress < 1 / 3) {
            phase = 'morning';
        } else if (progress < 2 / 3) {
            phase = 'evening';
        } else {
            phase = 'night';
        }

        setOverlayAttr('data-time', phase);
    }

    function stopClimateCycle() {
        if (climateTimer) {
            clearInterval(climateTimer);
            climateTimer = null;
        }
    }

    function startClimateCycle(fromUser = false) {
        stopClimateCycle();

        let current = overlay.getAttribute('data-hvac') || 'heating';

        if (fromUser) {
            current = current === 'heating' ? 'freezing' : 'heating';
            setOverlayAttr('data-hvac', current);
        } else if (!overlay.getAttribute('data-hvac')) {
            setOverlayAttr('data-hvac', 'heating');
        }

        climateTimer = setInterval(function () {
            if (active !== 'climate') return;
            if (!isSceneVisible) return;

            const hvac = overlay.getAttribute('data-hvac') || 'heating';
            const next = hvac === 'heating' ? 'freezing' : 'heating';

            animToggle = animToggle === 'a' ? 'b' : 'a';
            setOverlayAttr('data-anim', animToggle);
            setOverlayAttr('data-hvac', next);
        }, CLIMATE_MS);
    }



    function stopNetworkCycle() {
        if (networkTimer) {
            clearInterval(networkTimer);
            networkTimer = null;
        }
    }

    function startNetworkCycle(fromUser = false) {
        stopNetworkCycle();

        let current = overlay.getAttribute('data-network-state') || 'final';

        if (fromUser) {
            current = current === 'final' ? 'start' : 'final';
            setOverlayAttr('data-network-state', current);
        } else if (!overlay.getAttribute('data-network-state')) {
            setOverlayAttr('data-network-state', 'final');
        }

        networkTimer = setInterval(function () {
            if (active !== 'network') return;
            if (!isSceneVisible) return;

            const state = overlay.getAttribute('data-network-state') || 'final';
            const next = state === 'final' ? 'start' : 'final';

            animToggle = animToggle === 'a' ? 'b' : 'a';
            setOverlayAttr('data-anim', animToggle);
            setOverlayAttr('data-network-state', next);
        }, NETWORK_CYCLE_MS);
    }




    function setActive(key, fromUser = false) {
        active = key;
        setOverlayAttr('data-active', key);

        stopClimateCycle();
        stopNetworkCycle();

        if (key === 'climate') {
            startClimateCycle(fromUser);
        }

        if (key === 'network') {
            startNetworkCycle(fromUser);
        }

        if (fromUser) {
            animToggle = animToggle === 'a' ? 'b' : 'a';
            setOverlayAttr('data-anim', animToggle);

            if (key === 'light') {
                startTime = performance.now();
            }
        }

        syncBullets();
        syncMarkers();
        updateStatusLabel();
    }

    function clearAutoplayTimer() {
        if (autoplayTimer) {
            clearTimeout(autoplayTimer);
            autoplayTimer = null;
        }
    }

    function stopAutoplay() {
        userInteracted = true;
        autoplayRunning = false;
        clearAutoplayTimer();
    }

    function scheduleNextSequenceStep() {
        if (!autoplayRunning) return;
        if (userInteracted) return;
        if (!isSceneVisible) return;

        const item = sequence[sequenceIndex];
        setActive(item.key, false);

        if (item.key === 'light') {
            startTime = performance.now();
        } else {
            animToggle = animToggle === 'a' ? 'b' : 'a';
            setOverlayAttr('data-anim', animToggle);
        }

        autoplayTimer = setTimeout(function () {
            sequenceIndex = (sequenceIndex + 1) % sequence.length;
            scheduleNextSequenceStep();
        }, item.duration);
    }

    function startAutoplay() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (userInteracted) return;
        if (!isSceneVisible) return;
        if (autoplayRunning) return;

        autoplayRunning = true;

        const currentIndex = sequence.findIndex(function (item) {
            return item.key === active;
        });

        sequenceIndex = currentIndex >= 0 ? currentIndex : 0;
        scheduleNextSequenceStep();
    }

    function pauseAutoplay() {
        autoplayRunning = false;
        clearAutoplayTimer();
        stopNetworkCycle();
    }

    function tick(now) {
        if (isSceneVisible && active === 'light') {
            const progress = ((now - startTime) % LIGHT_SCENE_MS) / LIGHT_SCENE_MS;
            setTimePhase(progress);
        }

        rafId = requestAnimationFrame(tick);
    }

    bulletItems.forEach(function (item) {
        item.addEventListener('click', function () {
            stopAutoplay();
            setActive(item.getAttribute('data-exp-key'), true);
        });
    });

    markerButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            stopAutoplay();
            setActive(btn.getAttribute('data-key'), true);
        });
    });

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            isSceneVisible = entry.intersectionRatio >= 0.80;

            overlay.classList.toggle('is-in-view', isSceneVisible);
            overlay.classList.toggle('is-paused', !isSceneVisible);

            if (isSceneVisible) {
                if (!userInteracted) {
                    startAutoplay();
                }
            } else {
                pauseAutoplay();
            }
        });
    }, {
        threshold: [0, 0.80, 1]
    });

    observer.observe(visualBox);

    setActive(active, false);
    rafId = requestAnimationFrame(tick);
}